import { ErrorBase } from './ErrorBase';

export type RateLimitErrorCode = 'RATE_LIMIT_EXCEEDED';

export class RateLimitError extends ErrorBase<RateLimitErrorCode> {}
